import React, { Component } from 'react'
import { connect } from 'react-redux'
import yn from 'yn'

class BkFlowEditGuestFieldChildren extends Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const {
			configData,
			sessionProperty,
			configProperty,
			currentAdults,
			currentChildren,
			addChild,
			removeChild
		} = this.props

		const hotelLabels = configData.hotel.labels[0]
		const combinedGuestsValue = currentAdults + currentChildren

		// Disable guest field based on combinedGuestTotal or maximumChildren values in flowQueryConfig
		let guestFieldDisabled = false

		if (
			sessionProperty &&
			sessionProperty.combinedGuestTotal
		) {
			if (Number(combinedGuestsValue) === Number(sessionProperty.combinedGuestTotal)) {
				guestFieldDisabled = true
			} else if (Number(sessionProperty.maximumChildren) === Number(currentChildren)) {
				guestFieldDisabled = true
			}
		} else if (
			configProperty &&
			configProperty.combinedGuestTotal
		) {
			if (Number(combinedGuestsValue) === Number(configProperty.combinedGuestTotal)) {
				guestFieldDisabled = true
			} else if (Number(configProperty.maximumChildren) === Number(currentChildren)) {
				guestFieldDisabled = true
			}
		} else if (
			sessionProperty &&
			sessionProperty.maximumChildren &&
			Number(sessionProperty.maximumChildren) === Number(currentChildren)
		) {
			guestFieldDisabled = true
		} else if (
			configProperty &&
			configProperty.maximumChildren &&
			Number(configProperty.maximumChildren) === Number(currentChildren)
		) {
			guestFieldDisabled = true
		}

		return (
			<div className="bk-flow-edit-guest__field-input row center-xs">
				<p className="bk-flow-edit-guest__field-heading u-font-xs u-remove-margin">
					{ hotelLabels.children ? hotelLabels.children : 'Children' }
					{yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_GUEST_CHILD_AGE_LABELS) ?
						hotelLabels.childAgeGroup ? ' ' + hotelLabels.childAgeGroup : ' (0 - 12 years)'
						: null
					}
				</p>
				<button
					className="bk-flow-edit-guest__field-input-btn decrement col-xs"
					aria-label="Decrease the number of children"
					onClick={ currentChildren === 0 ? null : () => removeChild() }
					disabled={ currentChildren === 0 }
				>
					-
				</button>

				<div className="bk-flow-edit-guest__field-input-value col-xs">{ currentChildren }</div>

				<button
					className="bk-flow-edit-guest__field-input-btn increment col-xs"
					aria-label="Increase the number of children"
					onClick={ guestFieldDisabled ? null : () => addChild() }
					disabled={ guestFieldDisabled }
				>
					+
				</button>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	configData: state.configData.configuration
})

export default connect(mapStateToProps, null)(BkFlowEditGuestFieldChildren)


// WEBPACK FOOTER //
// ./src/components/edit/guest/elements/BkFlowEditGuestFieldChildren.js